import React from "react";

import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";

import { Sidebar, SidebarBody, SidebarItem, SidebarLabel } from "@components/Catalyst/sidebar";

import { Brand } from "@typed/categories";

import MenuTopLevel from "./MenuTopLevel";
import { getBrandedLinks, mainLinks } from "../data";

export const GacMobileSidebar = ({ brand, handleSearch }: { brand?: Brand; handleSearch: () => void }) => {
  const brandedLinks = !brand || brand.code === "gac" ? [] : [...getBrandedLinks(brand?.code ?? "gac")];
  const gacLinks = !brand || brand.code === "gac" ? [...getBrandedLinks(brand?.code ?? "gac"), ...mainLinks] : [...mainLinks];

  // const menuData: MenuData = { bgColor, brandedLinks, gacLinks };

  // Merge the brandedLinks and gacLinks arrays
  const combinedLinks = [...(brandedLinks ?? []), ...gacLinks]
    .filter((l) => l.mobileSort)
    .sort((a, b) => (a?.mobileSort ?? 0) - (b?.mobileSort ?? 0));

  return (
    <Sidebar className="dark bg-black">
      <SidebarBody>
        <SidebarItem onClick={handleSearch}>
          <MagnifyingGlassIcon />
          <SidebarLabel>Search</SidebarLabel>
        </SidebarItem>

        {combinedLinks.map((item) => (
          <MenuTopLevel key={item.label} item={item} />
        ))}
      </SidebarBody>
    </Sidebar>
  );
};
